module.exports = __webpack_public_path__ + "img/uk-flag.aa28c468.png";